import script from "./menuSettingPop.vue?vue&type=script&setup=true&name=menuSettingPop&lang=js"
export * from "./menuSettingPop.vue?vue&type=script&setup=true&name=menuSettingPop&lang=js"

const __exports__ = script;

export default __exports__